LS.util.route({
	'sell': {
		':load': 'sell',
		':unload': 'sell:unload'
	}
});